export class SelectionArticleGroupIdentity {
  public readonly groupId: string | null;
  public readonly articleUsageIds: string[] | null;

  public constructor(groupId: string | null, articleUsageIds: string[] | null) {
    this.groupId = groupId;
    this.articleUsageIds = articleUsageIds;
  }

  public equals(id: SelectionArticleGroupIdentity): boolean {
    if (!id) {
      return false;
    }
    return this.groupId === id.groupId && this.equalsUsageIds(id.articleUsageIds);
  }

  private equalsUsageIds(usageIds: string[] | null): boolean {
    if (!this.articleUsageIds && !usageIds) {
      return true;
    }
    if (!this.articleUsageIds || !usageIds) {
      return false;
    }
    if (this.articleUsageIds.length !== usageIds.length) {
      return false;
    }

    const cloneUsageIds: string[] = this.articleUsageIds.concat();
    for (const id of usageIds) {
      const index: number = cloneUsageIds.indexOf(id);
      if (index === -1) {
        return false;
      } else {
        cloneUsageIds.splice(index, 1);
      }
    }
    return true;
  }
}
